"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StoreCode = exports.STAGING_STORES = exports.STAGING_DOMAINS = exports.Locale = exports.Language = exports.Currency = void 0;

var _STORES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-template-curly-in-string */
var PRE_PROD_TOKEN = 'HQ4g9M72T4KA57yAQnhgeVF7BT30fzGybzLlKuwP8PZU9epjaExbKzZ50TUIKAWw'; // TODO: ENUMs need to be exported into @gymshark/types and built into packages.

var Currency;
exports.Currency = Currency;

(function (Currency) {
  Currency["AUD"] = "AUD";
  Currency["CAD"] = "CAD";
  Currency["DKK"] = "DKK";
  Currency["EUR"] = "EUR";
  Currency["NOK"] = "NOK";
  Currency["SEK"] = "SEK";
  Currency["CHF"] = "CHF";
  Currency["GBP"] = "GBP";
  Currency["USD"] = "USD";
})(Currency || (exports.Currency = Currency = {}));

var StoreCode;
exports.StoreCode = StoreCode;

(function (StoreCode) {
  StoreCode["S1"] = "s1";
  StoreCode["S2"] = "s2";
  StoreCode["S3"] = "s3";
  StoreCode["S4"] = "s4";
  StoreCode["XD"] = "xd";
  StoreCode["XS"] = "xs";
  StoreCode["XS2"] = "xs2";
  StoreCode["XS3"] = "xs3";
  StoreCode["XS4"] = "xs4";
  StoreCode["AU"] = "au";
  StoreCode["CA"] = "ca";
  StoreCode["DK"] = "dk";
  StoreCode["FI"] = "fi";
  StoreCode["FR"] = "fr";
  StoreCode["DE"] = "de";
  StoreCode["IE"] = "ie";
  StoreCode["NL"] = "nl";
  StoreCode["NO"] = "no";
  StoreCode["SE"] = "se";
  StoreCode["CH"] = "ch";
  StoreCode["GB"] = "gb";
  StoreCode["US"] = "us";
  StoreCode["EU"] = "eu";
  StoreCode["RW"] = "rw";
})(StoreCode || (exports.StoreCode = StoreCode = {}));

var Locale;
exports.Locale = Locale;

(function (Locale) {
  Locale["EN"] = "en";
  Locale["DE"] = "de";
  Locale["FR"] = "fr";
  Locale["NL"] = "nl";
  Locale["EN_AU"] = "en-AU";
  Locale["EN_CA"] = "en-CA";
  Locale["DA_DK"] = "da-DK";
  Locale["FI_FI"] = "fi-FI";
  Locale["FR_FR"] = "fr-FR";
  Locale["GA_IE"] = "ga-IE";
  Locale["NB_NO"] = "nb-NO";
  Locale["SV_SE"] = "sv-SE";
  Locale["EN_GB"] = "en-GB";
  Locale["EN_US"] = "en-US";
  Locale["EN_EU"] = "en-EU";
})(Locale || (exports.Locale = Locale = {}));

var Language;
exports.Language = Language;

(function (Language) {
  Language["EN"] = "en";
  Language["DE"] = "de";
  Language["FR"] = "fr";
  Language["NL"] = "nl";
  Language["GSW_CH"] = "gsw-CH";
})(Language || (exports.Language = Language = {}));

// Staging Stores
var s1 = {
  label: 'United Kingdom',
  currency: Currency.GBP,
  currencyFormat: '£{{amount}}',
  storeCode: StoreCode.S1,
  liveStoreCode: StoreCode.GB,
  language: Language.EN,
  locale: Locale.EN,
  domain: 'https://staging1.gymshark.com',
  nostoToken: PRE_PROD_TOKEN
};
var s2 = {
  label: 'Deutschland & Österreich',
  currency: Currency.EUR,
  currencyFormat: '€{{amount}}',
  storeCode: StoreCode.S2,
  liveStoreCode: StoreCode.DE,
  language: Language.DE,
  locale: Locale.DE,
  domain: 'https://staging2.gymshark.com',
  nostoToken: PRE_PROD_TOKEN
};
var s3 = {
  label: 'France',
  currency: Currency.AUD,
  currencyFormat: '${{amount}}',
  storeCode: StoreCode.S3,
  liveStoreCode: StoreCode.FR,
  language: Language.FR,
  locale: Locale.FR,
  domain: 'https://staging3.gymshark.com',
  nostoToken: PRE_PROD_TOKEN
};
var s4 = {
  label: 'The Netherlands',
  currency: Currency.CAD,
  currencyFormat: '${{amount}}',
  storeCode: StoreCode.S4,
  liveStoreCode: StoreCode.NL,
  language: Language.NL,
  locale: Locale.NL,
  domain: 'https://staging4.gymshark.com',
  nostoToken: PRE_PROD_TOKEN
}; // Live Stores

var STORES = (_STORES = {}, _defineProperty(_STORES, StoreCode.AU, {
  label: 'Australia and New Zealand',
  currency: Currency.AUD,
  currencyFormat: '$ {{amount}} AUD',
  storeCode: StoreCode.AU,
  liveStoreCode: StoreCode.AU,
  language: Language.EN,
  locale: Locale.EN_AU,
  domain: 'https://au.gymshark.com',
  nostoToken: 'HdWNk9ccjqWXF2HKkYG9UpOxSYD8SPEy6zrHkrOR0amVgpUz3yqpYb2ak0uCmvRA'
}), _defineProperty(_STORES, StoreCode.CA, {
  label: 'Canada',
  currency: Currency.CAD,
  currencyFormat: '$ {{amount}} CAD',
  storeCode: StoreCode.CA,
  liveStoreCode: StoreCode.CA,
  language: Language.EN,
  locale: Locale.EN_CA,
  domain: 'https://ca.gymshark.com',
  nostoToken: 'KaIJp4xk4JYryxALfQX9bSrmRsw1KZMmDhJDVknMLlMHb8S2MnKkRaYGGdhsv5SR'
}), _defineProperty(_STORES, StoreCode.DK, {
  label: 'Danmark',
  currency: Currency.DKK,
  currencyFormat: '{{amount}} DKK',
  storeCode: StoreCode.DK,
  liveStoreCode: StoreCode.DK,
  language: Language.EN,
  locale: Locale.DA_DK,
  domain: 'https://dk.gymshark.com',
  nostoToken: 'vHT6ApIFTqretWGsEQcyezZo3rAF8DpGDuB6YsZrec8m1hUDuTJgkdrKtsEd3SGt'
}), _defineProperty(_STORES, StoreCode.FI, {
  label: 'Finland',
  currency: Currency.EUR,
  currencyFormat: '{{amount}}€',
  storeCode: StoreCode.FI,
  liveStoreCode: StoreCode.FI,
  language: Language.EN,
  locale: Locale.FI_FI,
  domain: 'https://fi.gymshark.com',
  nostoToken: 'fKV6NxoGuwHoX9FjzQTXbBScrIOuUiyGweXQZ29PUbvwo5Ni3lklPzeDk3JcV3OW'
}), _defineProperty(_STORES, StoreCode.FR, {
  label: 'France',
  currency: Currency.EUR,
  currencyFormat: '{{amount}}€',
  storeCode: StoreCode.FR,
  liveStoreCode: StoreCode.FR,
  language: Language.FR,
  locale: Locale.FR_FR,
  domain: 'https://fr.gymshark.com',
  nostoToken: 'mgHO2A64gHKcIvvBVhkmf2E9vBlmkFBi4jyeDm48MQ8vsnTRCVPK85D8nD273W8s'
}), _defineProperty(_STORES, StoreCode.DE, {
  label: 'Deutschland & Österreich',
  currency: Currency.EUR,
  currencyFormat: '{{amount}}€',
  storeCode: StoreCode.DE,
  liveStoreCode: StoreCode.DE,
  language: Language.DE,
  locale: Locale.DE,
  domain: 'https://de.gymshark.com',
  nostoToken: 'epXpQaPCWW9RQD7z59ZY1lJ0NPd3i8A5iTCqvAVYHeIFUVDDQs1BL5Vd0htZW8sK'
}), _defineProperty(_STORES, StoreCode.NL, {
  label: 'The Netherlands',
  currency: Currency.EUR,
  currencyFormat: '€{{amount}}',
  storeCode: StoreCode.NL,
  liveStoreCode: StoreCode.NL,
  language: Language.NL,
  locale: Locale.NL,
  domain: 'https://nl.gymshark.com',
  nostoToken: 'krhGb0Y8WqAUABOL6r67kiQtBVwaTnQ82FYyiJCzRrjSMpkBmzr4qKtskFZ2gxP9'
}), _defineProperty(_STORES, StoreCode.NO, {
  label: 'Norge',
  currency: Currency.NOK,
  currencyFormat: '{{amount}} NOK',
  storeCode: StoreCode.NO,
  liveStoreCode: StoreCode.NO,
  language: Language.EN,
  locale: Locale.NB_NO,
  domain: 'https://no.gymshark.com',
  nostoToken: 'iNjyAgk7Qq9DXz8JiY57ecpJzYruJL1wEXdonym2VfV7YNDDC19Dqi9WvMs0404m'
}), _defineProperty(_STORES, StoreCode.SE, {
  label: 'Sverige',
  currency: Currency.SEK,
  currencyFormat: '{{amount}} SEK',
  storeCode: StoreCode.SE,
  liveStoreCode: StoreCode.SE,
  language: Language.EN,
  locale: Locale.SV_SE,
  domain: 'https://se.gymshark.com',
  nostoToken: 'FeASMKy3ILKZNHNjkfLTMOUDDQoa38yG8eaffNKPxOCSxNoRXValyMZruvfYw2xH'
}), _defineProperty(_STORES, StoreCode.CH, {
  label: 'Schweiz',
  currency: Currency.CHF,
  currencyFormat: '{{amount}} CHF',
  storeCode: StoreCode.CH,
  liveStoreCode: StoreCode.CH,
  language: Language.GSW_CH,
  locale: Locale.DE,
  domain: 'https://ch.gymshark.com',
  nostoToken: 'Haz6p44UPYJbQzeZVmfNQjCoaR38vIrLTBQxGmYwUmRxlgYzqozGTrEvS2GYOu5I'
}), _defineProperty(_STORES, StoreCode.GB, {
  label: 'United Kingdom',
  currency: Currency.GBP,
  currencyFormat: '£{{amount}}',
  storeCode: StoreCode.GB,
  liveStoreCode: StoreCode.GB,
  language: Language.EN,
  locale: Locale.EN_GB,
  domain: 'https://uk.gymshark.com',
  nostoToken: 'TXbbKAt9sbFC2pl2GXx8yB71z2Mkfu0UxvPZvsNyIQn8krtzLmjFy0LriGdI2PoE'
}), _defineProperty(_STORES, StoreCode.US, {
  label: 'United States',
  currency: Currency.USD,
  currencyFormat: '$ {{amount}} USD',
  storeCode: StoreCode.US,
  liveStoreCode: StoreCode.US,
  language: Language.EN,
  locale: Locale.EN_US,
  domain: 'https://www.gymshark.com',
  nostoToken: '9MEBZDWiLAL6gGWMuf7pegM0OEHlhtSdbmTU1XZgiCSoymZ2jVgNzobbZcxrnSx7'
}), _defineProperty(_STORES, StoreCode.EU, {
  label: 'Europe',
  currency: Currency.EUR,
  currencyFormat: '{{amount}}€',
  storeCode: StoreCode.EU,
  liveStoreCode: StoreCode.EU,
  language: Language.EN,
  locale: Locale.EN_EU,
  domain: 'https://eu.gymshark.com',
  nostoToken: '8nTCO7EwXm9UAt6ZD7BMoVwdkPw2X5rVTdVGSZzZHuFUju70zgnrIU9vQ1iZaRG7'
}), _defineProperty(_STORES, StoreCode.RW, {
  label: 'Rest of World',
  currency: Currency.USD,
  currencyFormat: '$ {{amount}} USD',
  storeCode: StoreCode.RW,
  liveStoreCode: StoreCode.RW,
  language: Language.EN,
  locale: Locale.EN,
  domain: 'https://row.gymshark.com',
  nostoToken: '8eeOqjC9Aq6M5X8mwzbF67jFmui7SxaFpL1g6gSdmpo6SgsDPUur3bgfXl7AzP9r'
}), _STORES);
var STAGING_STORES = {
  s1: s1,
  s2: s2,
  s3: s3,
  s4: s4,
  xd: {
    label: 'United States',
    currency: Currency.USD,
    currencyFormat: '${{amount}}',
    storeCode: StoreCode.XD,
    liveStoreCode: StoreCode.US,
    language: Language.EN,
    locale: Locale.EN_US,
    domain: 'https://dev.gymshark.com',
    nostoToken: PRE_PROD_TOKEN
  },
  xs: s1,
  xs2: s2,
  xs3: s3,
  xs4: s4
};
exports.STAGING_STORES = STAGING_STORES;
var STAGING_DOMAINS = ['https://staging1.gymshark.com', 'https://staging2.gymshark.com', 'https://staging3.gymshark.com', 'https://staging4.gymshark.com', 'https://dev.gymshark.com'];
exports.STAGING_DOMAINS = STAGING_DOMAINS;
var _default = STORES;
exports["default"] = _default;